import React from 'react';

import { media, style } from 'typestyle';

const sectionMargin = style(
    {},
    media({minWidth: 990}, {marginTop: 68})
);

const ContactUsSuccess: React.FC<{}> = () => {
   
    return <section className={sectionMargin}
        id='thanks'
        role='contentinfo'
        aria-label='Thank you for contacting us'>
            <p>
                <strong>Thank you for contacting Center for the Study of Services.</strong>
            </p>

            <p>We will respond to your inquiry soon.</p>

            <p>
                <a href='/'>return to home page</a>
            </p>
        </section>;    
}

export default ContactUsSuccess;